var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_4974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H39.5V39.5H0.5V0.5Z",
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_4974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1778 15.1777C31.1778 17.4931 30.4911 19.6169 29.3095 21.3893C28.4436 22.6807 27.3173 23.7769 26.0028 24.6073C24.6884 25.4378 23.2148 25.9843 21.6767 26.2117C21.1338 26.3075 20.5749 26.3554 20 26.3554C19.4252 26.3554 18.8663 26.3075 18.3234 26.2117C16.7853 25.9843 15.3117 25.4378 13.9972 24.6073C12.6828 23.7769 11.5565 22.6807 10.6906 21.3893C9.46475 19.5503 8.81435 17.3878 8.82234 15.1777C8.82234 8.99803 13.8204 4 20 4C26.1797 4 31.1778 8.99803 31.1778 15.1777Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7694 30.2996L32.1346 30.9223C31.5438 31.066 31.0807 31.5131 30.953 32.104L30.3941 34.4513C30.3255 34.7394 30.1782 35.0028 29.9685 35.212C29.7589 35.4212 29.4951 35.568 29.2069 35.6359C28.9186 35.7039 28.6171 35.6903 28.3361 35.5967C28.0551 35.5031 27.8056 35.3332 27.6156 35.106L19.9988 26.3554L12.382 35.1219C12.192 35.3492 11.9426 35.5191 11.6616 35.6126C11.3806 35.7062 11.0791 35.7198 10.7908 35.6519C10.5025 35.584 10.2388 35.4372 10.0291 35.228C9.81945 35.0188 9.6721 34.7554 9.60355 34.4672L9.04466 32.1199C8.97673 31.8327 8.83023 31.5701 8.62154 31.3614C8.41286 31.1527 8.15022 31.0062 7.86302 30.9383L5.22827 30.3155C4.95223 30.2494 4.69873 30.111 4.49373 29.9147C4.28873 29.7183 4.13961 29.471 4.06162 29.198C3.98364 28.9251 3.9796 28.6363 4.04992 28.3613C4.12023 28.0863 4.26238 27.8349 4.4618 27.6329L10.6894 21.4053C11.5553 22.6967 12.6816 23.7928 13.996 24.6233C15.3105 25.4538 16.7841 26.0003 18.3222 26.2277C18.8651 26.3235 19.424 26.3714 19.9988 26.3714C20.5737 26.3714 21.1326 26.3235 21.6755 26.2277C24.8531 25.7646 27.5837 23.9602 29.3082 21.4053L35.5358 27.6329C36.4141 28.4952 35.9829 30.0121 34.7694 30.2996ZM20.925 10.3553L21.8671 12.2396C21.9948 12.4951 22.3302 12.7506 22.6336 12.7985L24.3422 13.0859C25.428 13.2615 25.6835 14.0599 24.901 14.8424L23.5757 16.1677C23.3521 16.3913 23.2244 16.8224 23.3042 17.1418L23.6875 18.7865C23.9909 20.0799 23.3042 20.5909 22.1545 19.9043L20.5577 18.9622C20.3955 18.8756 20.2146 18.8304 20.0308 18.8304C19.8469 18.8304 19.666 18.8756 19.5038 18.9622L17.907 19.9043C16.7573 20.575 16.0706 20.0799 16.374 18.7865L16.7573 17.1418C16.8212 16.8384 16.7094 16.3913 16.4858 16.1677L15.1605 14.8424C14.378 14.0599 14.6335 13.2775 15.7193 13.0859L17.4279 12.7985C17.7154 12.7506 18.0507 12.4951 18.1784 12.2396L19.1206 10.3553C19.5836 9.33338 20.414 9.33338 20.925 10.3553Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSub);
export default __webpack_public_path__ + "static/media/ic_sub.5d18e647fc8b8acce2cce86d2f9523c7.svg";
export { ForwardRef as ReactComponent };